import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  textField: {
    margin: 10,
  },
  formControl: {
    margin: theme.spacing(1),
  },
  table: {
    width: 100,
  },
  tableContainer: {
    maxWidth: 1530,
    width: '100%',
    overflowX: 'scroll',
  },
}));

export default useStyles;
